/* eslint-disable */
import { ASession } from '../../common/ASession';
//import { IFbbSubmissionInfo } from '../IFbbSubmissionInfo'
import { PlanTagValue, RouterOptionConfig } from '../FbbEnum';

import * as wording from '../../../common/js/wording';
//import {SpecialOffer} from '../SpecialOffer'      // not used (design from FBB)
import { API } from '../../../data/API';

export class Plan extends ASession {
	protected sessionKey: string = 'Plan';
	protected planCode: string = '';

	protected effectivePrice: Number = 0;
	protected originalPrice: Number = 0;
	protected contractPeriod: Number = 0;
	// new
	protected routerConfig: Number = RouterOptionConfig.BuyRentalNot;
	protected mandCodeList: Array<string> = [];

	protected apiJson: string = '';
	protected tncJson: any = null;

	protected promoCode: string = '';

	//=================================================================================

	protected getData(): any {
		var json = {
			planCode: this.planCode,

			effectivePrice: this.effectivePrice,
			originalPrice: this.originalPrice,
			contractPeriod: this.contractPeriod,
			routerConfig: this.routerConfig,
			apiJson: this.apiJson,
			tncJson: this.tncJson,
			promoCode: this.promoCode,
			mandCodeList: this.mandCodeList,
		};

		//log.ot('Plan getData', json)
		return json;
	}
	protected setData(data: any) {
		this.planCode = data.planCode ?? '';

		this.effectivePrice = data.effectivePrice ?? 0;
		this.originalPrice = data.originalPrice ?? 0;
		this.contractPeriod = data.contractPeriod ?? 0;
		this.routerConfig = data.routerConfig ?? RouterOptionConfig.BuyRentalNot;
		this.apiJson = data.apiJson ?? {};
		this.tncJson = data.tncJson ?? {};
		this.promoCode = data.promoCode ?? '';
		this.mandCodeList = data.mandCodeList ?? [];
	}

	protected getDefaultData(): any {
		return {};
	}

	public parseApiResult(json: any) {
		this.apiJson = json;
		this.planCode = json['planCode'] ?? '';

		this.effectivePrice = json['effPrice'] ?? 0;
		this.originalPrice = json['oriPrice'] ?? 0;
		this.contractPeriod = json['contractPeriod'] ?? 0;
		this.routerConfig = json['routerConfig'] ?? RouterOptionConfig.BuyRentalNot;
	}

	public setTncJson(json: any) {
		let tempJson = json || {};
		if (!json.hasOwnProperty('tncList')) {
			tempJson = {
				tncList: json,
			};
		}
		this.tncJson = tempJson;
	}

	public setMandCodeList(mandCodeList: Array<string>) {
		let tempList = mandCodeList || [];
		this.mandCodeList = tempList;
	}

	public getPlanCode(): string {
		return (this.planCode ?? '') + '';
	}

	public getEffectivePrice(): Number {
		return this.effectivePrice;
	}

	public getOriginalPrice(): Number {
		return this.originalPrice;
	}

	public getContractPeriod(): Number {
		return this.contractPeriod;
	}

	public getRouterConfig(): Number {
		return this.routerConfig;
	}

	public setPromoCode(code: string) {
		this.promoCode = code;
	}

	public getPromoCode(): string {
		return this.promoCode + '';
	}

	public getTNCJson(): any {
		return this.tncJson['tncList'] ?? {};
	}

	public getMandCodeList(): Array<string> {
		return this.mandCodeList ?? [];
	}

	public getCleanMandCodeList(): Array<string> {
		if (Array.isArray(this.mandCodeList)) {
			return this.mandCodeList.filter((str) => str !== '');
		}
		return [];
	}

	public getMandCodeString(): string {
		let str = '';
		if (this.getMandCodeList().length > 0) {
			str = this.getMandCodeList().join(',');
		}
		return str;
	}

	public getMandCodeCleanString(): string {
		let str = '';
		if (this.getCleanMandCodeList().length > 0) {
			str = this.getCleanMandCodeList().join(',');
		}
		return str;
	}

	//=================================================================================
}
